import { IVesselOneParametrization } from "../../types/IVesselOneParametrization";
import { IVesselOnePart } from "../../types/IVesselOneParts";
import { VesselPartsParamsEnum } from "../../enums/VesselPartsParamsEnum";

export type IVesselParametersInput = Array<IVesselParameter>;

const PARAMS: IVesselParametersInput = [
  {
    id: VesselPartsParamsEnum.SIZE,
    collapsed: false,
    isPublic: false,
    params: [
      {
        name: "Max Bay",
        id: "maxBay",
        type: "selectRange",
        min: 1,
        max: 121,
        zeros: 3,
        step: 2,
      },
      {
        name: "Above Deck Tiers",
        id: "aboveDeck",
        min: 1,
        max: 20,
        type: "selectRange",
      },
      {
        name: "Below Deck Tiers",
        id: "belowDeck",
        min: 0,
        max: 50,
        type: "selectRange",
      },
      {
        name: "Max-Cell",
        id: "maxCell",
        min: 4,
        max: 26,
        type: "selectRange",
        zeros: 2,
      },
      {
        name: "Min-Cell",
        id: "minCell",
        min: 0,
        max: 1,
        type: "selectRange",
        zeros: 2,
      },
    ],
  },
  {
    id: VesselPartsParamsEnum.VISIBILITY,
    collapsed: false,
    isPublic: false,
    params: [
      {
        name: "Deck visible",
        id: "deckVisible",
        default: true,
        type: "toggle",
      },
      {
        name: "Shell visible",
        id: "shellVisible",
        default: true,
        type: "toggle",
      },
    ],
  },
  {
    id: VesselPartsParamsEnum.LABELS,
    collapsed: false,
    isPublic: false,
    params: [
      {
        name: "Show Bay Numbers",
        id: "bayNumbersVisible",
        default: true,
        type: "toggle",
      },
      {
        name: "Vessel Name",
        id: "labelVesselName",
        type: "input",
      },
      {
        name: "Carrier Name",
        id: "labelLateral",
        type: "input",
      },
      {
        name: "Country Name",
        id: "labelCountry",
        type: "input",
      },
      {
        name: "IMO",
        id: "labelIMOCode",
        type: "input",
      },
    ],
  },
  {
    id: VesselPartsParamsEnum.SEPARATORS,
    collapsed: false,
    isPublic: true,
    params: [
      {
        name: "Show Bulk Heads",
        id: "belowSeparatorsVisible",
        default: true,
        type: "toggle",
      },
      // {
      //   name: "Above Deck Lashes",
      //   id: "aboveSeparators",
      //   min: 0,
      //   max: 20,
      //   type: "selectRange",
      // },
    ],
  },
  {
    id: VesselPartsParamsEnum.TAIL_OPTIONS,
    collapsed: false,
    isPublic: false,
    params: [
      {
        name: "Propellers",
        id: "propellers",
        min: 1,
        max: 2,
        type: "selectRange",
        zeros: 0,
        step: 1,
      },
      {
        name: "Rudders",
        id: "rudders",
        min: 1,
        max: 2,
        type: "selectRange",
        zeros: 0,
        step: 1,
      },
    ],
  },
  {
    id: VesselPartsParamsEnum.COLORS,
    collapsed: true,
    isPublic: true,
    params: [
      {
        name: "Ship Main Color",
        id: "mainColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Ship Bottom Color",
        id: "bottomColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Bridge Color",
        id: "bridgeColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Cranes Color",
        id: "cranesColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Smoke Main Color",
        id: "smokeBottomColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Smoke Top Color",
        id: "smokeTopColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Lashing Bridge Color",
        id: "separatorColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Trans Bulkhead Color",
        id: "belowSeparatorColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Bow Labels Color",
        id: "labelsNoseColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Carrier Labels Color",
        id: "labelsSideColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Stern Labels Color",
        id: "labelsTailColor",
        type: "iroColor",
        className: "border-bottom",
      },
      {
        name: "Bay Labels Color",
        id: "labelsBaysColor",
        type: "iroColor",
        className: "border-bottom",
      },
    ],
  },
  {
    id: VesselPartsParamsEnum.SLOTS,
    collapsed: false,
    isPublic: true,
    params: [
      {
        type: "bay-slots",
        id: "parts",
        name: "",
        value: [],
      },
    ],
  },
];

export const VesselOneParameters = PARAMS;

interface IVesselParameter {
  id: VesselPartsParamsEnum;
  collapsed?: boolean;
  isPublic?: boolean;
  params: Array<IVesselSubParameters>;
}

type IVesselSubParameters = {
  name: string;
  id: keyof IVesselOneParametrization;
  className?: string;
} & (
  | {
      type: "selectRange";
      min: number;
      max: number;
      zeros?: number;
      step?: number;
    }
  | {
      type: "toggle";
      default: boolean;
    }
  | {
      type: "input";
    }
  | {
      type: "bay-slots";
      value: Array<IVesselOnePart>;
    }
  | {
      type: "iroColor";
    }
);
